export default __webpack_public_path__ + "static/media/8、首页冷链果汁.33129419.jpg";